export default "__VITE_ASSET__BupgjwTW__"